import React, { useState, useRef, useEffect } from 'react';
import './navbar.css';
import { Link, NavLink } from 'react-router-dom';
import { SlMenu } from "react-icons/sl";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { FaFacebookF } from 'react-icons/fa6';
import { IoClose } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa";
import { categories } from "../../categories";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [productOpen, setProductOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setProductOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);



    const email = 'director@roobaswastha.com ';
    const facebookUrl = 'https://www.facebook.com/share/1EN57HD9ny/';
    const instagramUrl = 'https://www.instagram.com/rooba_swastha_pharmaceuticals?igsh=MTYyYWZtMG9zdTBmag==';
    const phone = '+91 9344931339';

    const handleToggle = () => {
        setMenuOpen(!menuOpen);

    };

    return (
        <>
            {menuOpen && (
                <div
                    className="menu-overlay show"
                    onClick={() => setMenuOpen(false)}
                ></div>
            )}
            <div className="navtop">
                <div className="navtopcontainer">
                    <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className='mediaicons'><FaFacebookF /></a>
                    <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className='mediaicons'><FaInstagram /></a>
                    <a href={`mailto:${email}`} className='mail'>{email}</a>
                </div>
            </div>

            <div className='navbar'>
                <div className='navbar-container'>
                    <div className='logo-container'>
                        <Link to="/"> <img src="/uploads/rooba-logo.jpg" alt="Rooba Swastha Logo" className='logo' /></Link>
                    </div>

                    {/* Toggle Button */}
                    <div className='navbar-toggle' onClick={handleToggle}>
                        {menuOpen ? <IoClose /> : <SlMenu />}
                    </div>

                    <div className={`nav-links-container ${menuOpen ? "show-menu" : ""}`}>
                        {/* <div className="drawer-logo">
                            <img src={require("../../assets/logo rev.jpg")} alt="Logo" />
                        </div> */}

                        <ul className="nav-links" onClick={() => setMenuOpen(false)}>
                            <li><NavLink to="/" style={{ color: "#ff7f00" }}>Home</NavLink></li>
                            <li><NavLink to="/about" >About Us</NavLink></li>

                            <li ref={dropdownRef} className={`dropdown ${productOpen ? "open" : ""}`}>
                                <div
                                    className="dropdown-title"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setProductOpen(!productOpen);
                                    }}
                                >
                                    <span>Products</span>
                                    <FaChevronDown
                                        className={`dropdown-icon ${productOpen ? "rotate" : ""}`}
                                    />
                                </div>

                                <ul className={`dropdown-menu ${productOpen ? "show" : ""}`}>
                                    {categories.map((cat) => (
                                        <li key={cat.id}>
                                            <NavLink
                                                to={`/products/${cat.id}`}
                                                onClick={() => {
                                                    setMenuOpen(false);
                                                    setProductOpen(false);
                                                }}
                                            >
                                                {cat.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>


                            <li><NavLink to="/gallery">Gallery</NavLink></li>
                            <li><NavLink to="/contact" >Contact Us</NavLink></li>
                        </ul>

                        <a href={`tel:${phone}`} className='ph-number btn'>
                            <FaPhoneAlt />
                            <p>{phone}</p>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Navbar;
